import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import PresetsService from "../../backend/PresetsService";
import LobbyRowService from "../../backend/LobbyRowService";
import BrandStyleSheet from "../precheckin/BrandStyleSheet";
import Property from "../../model/property";
import TopBar from "../../components/navbar/TopBar";
import LoadingIcon from "../../components/LoadingIcon";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { LazyLoadImage } from "react-lazy-load-image-component";
import placeholderSquare from "../../assets/placeholder-square.png";
import storeFunction from "../../utils/storeFunction";
import {
  ProductPanel,
  ListHeaderTitle,
  ListSubTitle,
  Item,
  StyledLink,
  ItemWrap,
  ImageItem,
  ImageBag,
} from "./LobbyrowStyle";
import FulfillmentNode from "../../model/fulfillmentNode";
import ButtonLanguage from "../../components/ButtonLanguage";
import { isEmpty } from "lodash";

class LobbyRowHome extends Component {
  state = {
    propertyUid: null,
    lobbyRowId: null,
    property: null,
    presets: null,
    lobbyRow: null,
    error: false,
    loading: true,
    language: "en",
  };

  componentDidMount() {
    window.scrollTo(0, 0);
    const { propertyUid, lobbyId } = this.props.match.params;
    const splitLobbyId = lobbyId && lobbyId.split("?");
    const lId = splitLobbyId && splitLobbyId[0];

    const query = new URLSearchParams(
      this.props.location.search ||
        (splitLobbyId.length > 1 ? `?${splitLobbyId[1]}` : "")
    );
    const i18nLanguage = this.props.i18n.language;
    const language = query.get("language") || i18nLanguage || "en";
    if (language !== i18nLanguage) {
      this.props.i18n.changeLanguage(language);
    }
    const token = query.get("token");
    localStorage.clear();

    FulfillmentNode.setToken(token);
    this.setState({
      propertyUid: propertyUid,
      lobbyRowId: lId,
      language: language,
    });
    this.getLobbyRow(propertyUid, lId, language);
    this.getPreset(propertyUid);
  }

  getPreset = async (propertyUid) => {
    if (propertyUid) {
      try {
        await PresetsService.getPreset(propertyUid)
          .then((response) => {
            const presets = response.data;
            Property.setPreset(propertyUid, presets);
            if (presets) {
              if (!isEmpty(presets.app_webstore_favicon_url)) {
                const favicon = document.getElementById("favicon");
                if (favicon) favicon.href = presets.app_webstore_favicon_url;
                const appleFavicon = document.getElementById("apple-favicon");
                if (appleFavicon)
                  appleFavicon.href = presets.app_webstore_favicon_url;
              }
              const desktopContainer =
                document.getElementById("desktop-container");
              if (desktopContainer) {
                if (!isEmpty(presets.app_home_webapp_desktop_bg)) {
                  desktopContainer.style.backgroundColor =
                    presets.app_home_webapp_desktop_bg;
                }
              }
              const root = document.getElementById("root");
              const tabletContainer =
                document.getElementById("tablet-container");
              const wrapper = tabletContainer ? tabletContainer : root;
              if (wrapper) {
                if (!isEmpty(presets.app_home_global_background_color)) {
                  wrapper.style.backgroundColor =
                    presets.app_home_global_background_color;
                }
              }
            }
            this.setState({
              success: true,
              loading: false,
              presets: presets,
            });
          })
          .catch((err) => {
            this.setState({ loading: false, success: false, error: true });
            throw err;
          });
      } catch (err) {
        this.setState({ loading: false, success: false, error: true });
      }
    }
  };

  getLobbyRow = async (propertyUid, lobbyId, language = "en") => {
    if (lobbyId) {
      try {
        await LobbyRowService.getLobbyRow(propertyUid, lobbyId, language)
          .then((response) => {
            const lobbyRow = response.data;
            Property.setData(lobbyRow);
            this.setState({
              lobbyRow,
              success: true,
            });
          })
          .catch((err) => {
            this.setState({ loading: false, success: false, error: true });
            throw err;
          });
      } catch (err) {
        this.setState({ loading: false, success: false, error: true });
      }
    }
  };

  handleSelectedLanguage = () => {
    const { propertyUid, lobbyRowId } = this.state;
    const language = this.props.i18n.language;
    this.setState({
      language: language,
    });
    this.getLobbyRow(propertyUid, lobbyRowId, language);
    this.props.history.replace({
      pathname: `/${propertyUid}/lobby/${lobbyRowId}?language=${language}&token=${FulfillmentNode.getToken()}`,
    });
  };

  render() {
    const {
      propertyUid,
      lobbyRowId,
      language,
      lobbyRow,
      presets,
      error,
      loading,
    } = this.state;
    const brandStyle = presets && presets.app_brand_stylesheet;
    let windowWidth = window.innerWidth;
    let windowHeight = (window.innerHeight * 0.4).toFixed(0);
    if (windowWidth > 1280) {
      windowWidth = 1280;
    }
    if (brandStyle) {
      if (windowWidth <= 768) {
        windowHeight = 400;
      } else if (windowWidth > 768) {
        windowHeight = window.innerHeight;
      }
    } else if (windowWidth > 400) {
      windowHeight = 400;
    }
    return (
      <>
        {loading && !error && (
          <div
            style={{
              display: "flex",
              height: "100vh",
              alignItems: "center",
              justifyContent: "center",
            }}>
            <LoadingIcon loadingState={true} />
          </div>
        )}
        {!loading && !error && (
          <div className="flex flex-col w-full">
            <BrandStyleSheet brandStyleSheet={presets.app_brand_stylesheet} />
            <div className="flex flex-col h-full">
              <TopBar
                title={lobbyRow && lobbyRow.title ? lobbyRow.title : undefined}
                currentPage={"productDetail"}
              />
              <section
                id="content"
                className="sectionContent w-full h-full flex-1 md:flex-0 md:mb-0 mb-20">
                {lobbyRow && lobbyRow.picture && (
                  <LazyLoadImage
                    placeholderSrc={placeholderSquare}
                    alt={lobbyRow.title}
                    src={storeFunction.resizeImage(lobbyRow.picture, 600, 600)}
                    wrapperClassName="w-full h-50"
                    style={{
                      objectFit: "cover",
                      width: "100%",
                      maxHeight: `${windowHeight}px`,
                      display: "absolute",
                    }}
                  />
                )}
                <div className="flex flex-col justify-center h-full">
                  <ul className="flex-1 w-full flex flex-col">
                    {lobbyRow &&
                      lobbyRow.fulfillmentnodes &&
                      lobbyRow.fulfillmentnodes.map(
                        (fulfillmentNode, index) =>
                          fulfillmentNode.title && (
                            <Item key={index}>
                              <StyledLink
                                to={{
                                  pathname:
                                    lobbyRow &&
                                    `/${propertyUid}/lobby/${lobbyRowId}/fulfillments/${fulfillmentNode.core_id}?language=${language}`,
                                }}>
                                <ItemWrap className="flex">
                                  <ImageItem
                                    has_image={
                                      (fulfillmentNode.icon_type === "Font" &&
                                        fulfillmentNode.font_icon.length > 0) ||
                                      fulfillmentNode.icon ||
                                      fulfillmentNode.picture
                                    }
                                    backgroundColor={
                                      presets.app_home_icon_bg_color
                                    }
                                    color={presets.app_home_icon_font_color}>
                                    {fulfillmentNode.icon_type === "Font" &&
                                    fulfillmentNode.font_icon.length > 0 ? (
                                      <FontAwesomeIcon
                                        icon={
                                          require("@fortawesome/free-solid-svg-icons")[
                                            `fa${
                                              fulfillmentNode.font_icon
                                                .charAt(0)
                                                .toUpperCase() +
                                              fulfillmentNode.font_icon.slice(1)
                                            }`
                                          ]
                                        }
                                      />
                                    ) : (
                                      (fulfillmentNode.icon ||
                                        fulfillmentNode.picture) && (
                                        <ImageBag
                                          src={storeFunction.resizeImage(
                                            fulfillmentNode.icon ||
                                              fulfillmentNode.picture,
                                            600,
                                            600
                                          )}
                                        />
                                      )
                                    )}
                                  </ImageItem>
                                  <ProductPanel
                                    padding={
                                      (fulfillmentNode.icon_type === "Font" &&
                                        fulfillmentNode.font_icon.length > 0) ||
                                      fulfillmentNode.icon ||
                                      fulfillmentNode.picture
                                        ? null
                                        : "0"
                                    }>
                                    <ListHeaderTitle
                                      app_home_list_item_title_color={
                                        presets.app_home_list_item_title_color
                                      }
                                      className={"itemListTextStoreTitle"}>
                                      {fulfillmentNode.title}
                                    </ListHeaderTitle>
                                    {fulfillmentNode.subtitle && (
                                      <ListSubTitle
                                        className={
                                          "itemListTextStoreSubTitle m-0"
                                        }
                                        haveImage={
                                          fulfillmentNode.icon ||
                                          fulfillmentNode.picture
                                        }
                                        app_home_list_item_subtitle_color={
                                          presets.app_home_list_item_subtitle_color
                                        }>
                                        {fulfillmentNode.subtitle}
                                      </ListSubTitle>
                                    )}
                                  </ProductPanel>
                                </ItemWrap>
                              </StyledLink>
                            </Item>
                          )
                      )}
                  </ul>
                </div>
              </section>
            </div>
          </div>
        )}
        <ButtonLanguage
          onSelected={() => this.handleSelectedLanguage()}
          currentPage="store"
          showButton={true}
        />
      </>
    );
  }
}

export default withTranslation()(LobbyRowHome);
